import { browser } from '$app/environment';

/**
 * Phone-class device: the primary input is touch AND the physical screen's
 * shorter side is under 600 CSS px (Android's sw600dp phone/tablet boundary;
 * the largest phones are ~440, the smallest tablets 744). Tablets deliberately
 * classify with desktops: their GPUs and memory budgets handle desktop-grade
 * work. Screen dimensions and pointer capability are stable under rotation and
 * window resizing, and ignore the user agent (iPadOS masquerades as macOS).
 */
export function isPhoneClassDevice(): boolean {
	if (!browser) return false;
	return (
		window.matchMedia('(pointer: coarse)').matches &&
		Math.min(window.screen.width, window.screen.height) < 600
	);
}

/**
 * Any iOS/iPadOS device. The UA regex alone misses modern iPads: iPadOS
 * Safari reports a desktop macOS user agent by default, so the Mac spelling
 * plus a touchscreen (no Mac has one) is the iPad.
 */
export function isIosDevice(): boolean {
	if (!browser) return false;
	return (
		/iPad|iPhone|iPod/.test(navigator.userAgent) ||
		(navigator.userAgent.includes('Mac') && navigator.maxTouchPoints > 1)
	);
}
